import { render, staticRenderFns } from "./DealList.vue?vue&type=template&id=233d263a"
import script from "./DealList.vue?vue&type=script&lang=js"
export * from "./DealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealListItem: require('/app/components/DealListItem.vue').default})
